<template>
    <v-navigation-drawer width="350" fixed temporary v-model="isSidebarActive">
        <v-toolbar flat>
            <v-toolbar-title>{{ sidebarTitle }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="isSidebarActive = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>

            <template v-slot:extension>
                <v-tabs
                    v-model="currentTab"
                    fixed-tabs
                    background-color="#064171"
                    dark
                >
                    <v-tab value="toc">
                        <v-icon>mdi-book-open-variant</v-icon>
                    </v-tab>
                    <v-tab value="bookmarks">
                        <v-icon>mdi-bookmark-check</v-icon>
                    </v-tab>
                    <v-tab value="highlights">
                        <v-icon>mdi-format-color-highlight</v-icon>
                    </v-tab>
                </v-tabs>
            </template>
        </v-toolbar>

        <v-tabs-items v-model="currentTab">
            <v-tab-item :value="0">
                <v-list>
                    <v-list-item
                        @click="selectTOC(item)"
                        link
                        v-for="item in toc"
                        :key="item.href"
                    >
                        <v-list-item-title>
                            {{ item.label }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-tab-item>
            <v-tab-item :value="1">
                <v-container v-if="currentBookmarks.length === 0">
                    There are no bookmarks assigned for this book yet.
                </v-container>
                <v-list v-else>
                    <v-list-item
                        @click="selectPage(item)"
                        link
                        v-for="item in currentBookmarks"
                        :key="item.pageLink"
                    >
                        <v-list-item-title>
                            Chapter {{ item.chapter }} Page
                            {{ item.chapterPage }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-tab-item>
            <v-tab-item :value="2">
                <v-container v-if="currentHighlights.length === 0">
                    There are no highlights assigned for this book yet.
                </v-container>
                <v-list v-else>
                    <v-list-item
                        link
                        v-for="item in currentHighlights"
                        :key="item.id"
                    >
                        <v-list-item-title @click="selectHighlight(item)">
                            "...{{ item.text }}..."
                        </v-list-item-title>
                        <v-list-item-action>
                            <v-btn
                                small
                                @click.capture="removeHighlight(item)"
                                text
                            >
                                Remove
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-tab-item>
        </v-tabs-items>
    </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { mapFields } from "vuex-map-fields";
import { EpubCFI } from "epubjs";

export default {
    name: "Sidebar",
    data() {
        return {};
    },
    computed: {
        ...mapFields([
            "isSidebarActive",
            "rendition",
            "currentHighlights",
            "currentTab",
        ]),
        ...mapState(["currentBook", "currentBookmarks", "currentPage", "toc"]),
        sidebarTitle() {
            switch (this.currentTab) {
                case 0:
                    return "Table of Contents";
                case 1:
                    return "Bookmarks";
                case 2:
                    return "Highlights";
            }

            return "";
        },
    },
    methods: {
        ...mapMutations([
            "setHighlightState",
            "setCurrentPageState",
            "setSidebar",
        ]),
        sidebarNavContent(navbarView) {
            this.sidebarContent = navbarView;
        },
        selectTOC(item) {
            this.rendition.display(item.href);
        },
        selectPage(item) {
            this.rendition.display(item.pagePath);
            this.setCurrentPageState(item);
        },
        selectHighlight(item) {
            this.rendition.display(item.id);
        },
        removeHighlight(item) {
            const range = new EpubCFI(item.id);
            this.rendition.annotations.remove(range, "highlight");

            this.$store.commit("setHighlightState", {
                ...item,
                canDelete: true,
            });
        },
        toggleSidebar() {
            this.setSidebar();
        },
    },
};
</script>
